import i18n from "../../../../../@common/i18n/i18n.client"
import type { PastChallenges } from "../../../../api/hooks/past"
import { format } from "../../../../utils"
import type { ListItem } from "../../../@shared/challenges"

export const normalizeChallenges = (challenges: PastChallenges): ListItem[] =>
	challenges.map(c => ({
		id: c.id,
		title: c.name,
		slug: c.slug,
		status: c.status.current.name,
		subtitle: {
			label: i18n.t("ended", { ns: "past" }),
			time: format(c.entriesCloseAt, "MMM d, yyyy"),
		},
		image: {
			src: c.images.thumbnail640x640.url.jpeg,
			lowSrc: c.images.thumbnail640x640.url.loader.base64,
		},
	}))
